import { LinkPreview } from "@/src/models/link-preview.model";
import { previewFaviconUrl, previewSourceLabel } from "@/src/utils/link-preview.utils";
import { Global } from "iconsax-react-nativejs";
import { useState } from "react";
import { Image, Text, View } from "react-native";

type PreviewFooterProps = Readonly<{ preview: LinkPreview; iconColor: string }>;

/** Favicon + "Site · domain", matching the Selisian app's card footer. */
const PreviewFooter = ({ preview, iconColor }: PreviewFooterProps) => {
  const favicon = previewFaviconUrl(preview.url);
  const [failed, setFailed] = useState(false);
  return (
    <View className="flex-row items-center gap-1.5" testID="link-preview-footer">
      {favicon && !failed ? (
        <Image
          source={{ uri: favicon }}
          style={{ width: 14, height: 14 }}
          onError={() => setFailed(true)}
          accessibilityIgnoresInvertColors
          testID="link-preview-favicon"
        />
      ) : (
        <Global size={14} color={iconColor} />
      )}
      <Text className="text-xs text-slate-default flex-1" numberOfLines={1}>
        {previewSourceLabel(preview)}
      </Text>
    </View>
  );
};

export default PreviewFooter;
